<template>
  <div class="tw-w-full tw-p-0">
    <div class="colapse-area tw-p-2">
      <div v-if="isSigre" class="colapse">
        <strong>{{ $gettext("OWNER") }}:</strong>
        {{ $gettext("SIGRE") }}
      </div>
      <div v-else-if="isWaste" class="colapse">
        <strong>{{ $gettext("OWNER") }}:</strong>
        {{ $gettext("WASTE") }}
      </div>
      <div v-else class="colapse">
        <strong>{{ $gettext("OWNER") }}:</strong>
        {{ ownerName }}
        {{isColapseStartIcon}}
      </div>
      <div v-if="!isSigre && !isWaste" class="colapse">
        <strong>{{ $gettext("STAY_PERIOD") }}: </strong>
        <span v-if="isCurrentOwner">{{ $gettext('CURRENT')}}</span>
        <span v-else>{{ $gettext('OLD')}}</span>
      </div>
      <div class="box-buttom">
        <q-btn
          flat
          icon="mdi-arrow-collapse-vertical"
          class="tw-text-warmGray-100"
          @click="openCloseTable"
        />
      </div>
      <br />
      <div v-if="!isSigre && !isWaste" class="colapse">
        <strong>{{ $gettext("CPF/CNPJ") }}</strong
        >: {{ ownerDocument }}
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'HeaderColapseTable',
  props: {
    consumerUnit: String,
    protocol: String,
    ownerName: String,
    ownerDocument: String,
    isCurrentOwner: Boolean,
    isSigre: Boolean,
    isWaste: Boolean
  }
})
export default class HeaderColapseTable extends Vue {
  openCloseTable () {
    this.$emit('colapse')
  }
}
</script>

<style lang="scss" scoped>
@import "tailwindcss/utilities";

.colapse-area {
  background-color: #5898aa;
  display: grid;
  grid-template-columns: 32% 32% 33.5% 0.5%;
}

.colapse {
  color: #fff;
  padding: 8px 20px;
}

.box-buttom {
  grid-column-start: 4;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 35px;
}
</style>
